import * as yup from "yup";

export const changePasswordFormSchema = yup.object({
    otp:yup.string().required("Please enter your otp").min(4, "OTP must be at least 4 characters").max(6, "OTP must be at most 6 characters"),
    oldPassword:yup.string().required("Please enter your old password").min(8, "Old Password must be at least 8 characters"),
    newPassword:yup.string().required("Please enter your New password").min(8, "New Password must be at least 8 characters"),
    confirmNewPassword:yup.string().required("Please enter your Confirm password").min(8, "Confirm Password must be at least 8 characters"),
})


export const otpAuthFormSchema = yup.object({
    otp:yup.string().required("Please enter your otp").min(4, "OTP must be at least 4 characters").max(6, "OTP must be at most 6 characters"),
})


export const addPhoneNumberFormSchema = yup.object({
    countryCode: yup.string().required("Country code is required"),
    phone:yup.string().required("Please enter phone number"),
    // otp:yup.string().required("Please enter your otp").min(4, "OTP must be at least 4 characters").max(6, "OTP must be at most 6 characters"),
})